var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.2 21a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9h12.6a.9.9 0 0 1 .9.9v2.7h-1.8V4.8H7.1v14.4h10.8v-1.8h1.8v2.7a.9.9 0 0 1-.9.9zm11.7-5.4v-2.7h-6.3v-1.8h6.3V8.4l4.5 3.6z"
  })));
};
export default SvgLogout;